/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { opexesSalaryCopyCreate } from '../fn/opexs-salary/opexes-salary-copy-create';
import { OpexesSalaryCopyCreate$Params } from '../fn/opexs-salary/opexes-salary-copy-create';
import { opexesSalaryCreate } from '../fn/opexs-salary/opexes-salary-create';
import { opexesSalaryCreate$FormData } from '../fn/opexs-salary/opexes-salary-create-form-data';
import { OpexesSalaryCreate$FormData$Params } from '../fn/opexs-salary/opexes-salary-create-form-data';
import { OpexesSalaryCreate$Params } from '../fn/opexs-salary/opexes-salary-create';
import { opexesSalaryCreate$XWwwFormUrlencoded } from '../fn/opexs-salary/opexes-salary-create-x-www-form-urlencoded';
import { OpexesSalaryCreate$XWwwFormUrlencoded$Params } from '../fn/opexs-salary/opexes-salary-create-x-www-form-urlencoded';
import { opexesSalaryDestroy } from '../fn/opexs-salary/opexes-salary-destroy';
import { OpexesSalaryDestroy$Params } from '../fn/opexs-salary/opexes-salary-destroy';
import { opexesSalaryEnumsRetrieve } from '../fn/opexs-salary/opexes-salary-enums-retrieve';
import { OpexesSalaryEnumsRetrieve$Params } from '../fn/opexs-salary/opexes-salary-enums-retrieve';
import { opexesSalaryList } from '../fn/opexs-salary/opexes-salary-list';
import { OpexesSalaryList$Params } from '../fn/opexs-salary/opexes-salary-list';
import { opexesSalaryPartialUpdate } from '../fn/opexs-salary/opexes-salary-partial-update';
import { opexesSalaryPartialUpdate$FormData } from '../fn/opexs-salary/opexes-salary-partial-update-form-data';
import { OpexesSalaryPartialUpdate$FormData$Params } from '../fn/opexs-salary/opexes-salary-partial-update-form-data';
import { OpexesSalaryPartialUpdate$Params } from '../fn/opexs-salary/opexes-salary-partial-update';
import { opexesSalaryPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs-salary/opexes-salary-partial-update-x-www-form-urlencoded';
import { OpexesSalaryPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-salary/opexes-salary-partial-update-x-www-form-urlencoded';
import { opexesSalaryRetrieve } from '../fn/opexs-salary/opexes-salary-retrieve';
import { OpexesSalaryRetrieve$Params } from '../fn/opexs-salary/opexes-salary-retrieve';
import { opexesSalaryUpdate } from '../fn/opexs-salary/opexes-salary-update';
import { opexesSalaryUpdate$FormData } from '../fn/opexs-salary/opexes-salary-update-form-data';
import { OpexesSalaryUpdate$FormData$Params } from '../fn/opexs-salary/opexes-salary-update-form-data';
import { OpexesSalaryUpdate$Params } from '../fn/opexs-salary/opexes-salary-update';
import { opexesSalaryUpdate$XWwwFormUrlencoded } from '../fn/opexs-salary/opexes-salary-update-x-www-form-urlencoded';
import { OpexesSalaryUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-salary/opexes-salary-update-x-www-form-urlencoded';
import { BackendSalaryDto } from '../models/backend-salary-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsSalaryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `opexesSalaryList()` */
  static readonly OpexesSalaryListPath = '/api/opexes/salary/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryList()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryList$Response(
    params?: OpexesSalaryList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendSalaryDto>>> {
    return opexesSalaryList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryList(params?: OpexesSalaryList$Params, context?: HttpContext): Observable<Array<BackendSalaryDto>> {
    return this.opexesSalaryList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendSalaryDto>>): Array<BackendSalaryDto> => r.body),
    );
  }

  /** Path part for operation `opexesSalaryCreate()` */
  static readonly OpexesSalaryCreatePath = '/api/opexes/salary/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesSalaryCreate$Response(
    params: OpexesSalaryCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesSalaryCreate(params: OpexesSalaryCreate$Params, context?: HttpContext): Observable<BackendSalaryDto> {
    return this.opexesSalaryCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesSalaryCreate$XWwwFormUrlencoded$Response(
    params: OpexesSalaryCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesSalaryCreate$XWwwFormUrlencoded(
    params: OpexesSalaryCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesSalaryCreate$FormData$Response(
    params: OpexesSalaryCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesSalaryCreate$FormData(
    params: OpexesSalaryCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /** Path part for operation `opexesSalaryRetrieve()` */
  static readonly OpexesSalaryRetrievePath = '/api/opexes/salary/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryRetrieve$Response(
    params: OpexesSalaryRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryRetrieve(params: OpexesSalaryRetrieve$Params, context?: HttpContext): Observable<BackendSalaryDto> {
    return this.opexesSalaryRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /** Path part for operation `opexesSalaryUpdate()` */
  static readonly OpexesSalaryUpdatePath = '/api/opexes/salary/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesSalaryUpdate$Response(
    params: OpexesSalaryUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesSalaryUpdate(params: OpexesSalaryUpdate$Params, context?: HttpContext): Observable<BackendSalaryDto> {
    return this.opexesSalaryUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesSalaryUpdate$XWwwFormUrlencoded$Response(
    params: OpexesSalaryUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesSalaryUpdate$XWwwFormUrlencoded(
    params: OpexesSalaryUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesSalaryUpdate$FormData$Response(
    params: OpexesSalaryUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesSalaryUpdate$FormData(
    params: OpexesSalaryUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /** Path part for operation `opexesSalaryDestroy()` */
  static readonly OpexesSalaryDestroyPath = '/api/opexes/salary/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryDestroy$Response(
    params: OpexesSalaryDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesSalaryDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryDestroy(params: OpexesSalaryDestroy$Params, context?: HttpContext): Observable<void> {
    return this.opexesSalaryDestroy$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `opexesSalaryPartialUpdate()` */
  static readonly OpexesSalaryPartialUpdatePath = '/api/opexes/salary/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesSalaryPartialUpdate$Response(
    params: OpexesSalaryPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesSalaryPartialUpdate(
    params: OpexesSalaryPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesSalaryPartialUpdate$XWwwFormUrlencoded$Response(
    params: OpexesSalaryPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesSalaryPartialUpdate$XWwwFormUrlencoded(
    params: OpexesSalaryPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesSalaryPartialUpdate$FormData$Response(
    params: OpexesSalaryPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesSalaryPartialUpdate$FormData(
    params: OpexesSalaryPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendSalaryDto> {
    return this.opexesSalaryPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /** Path part for operation `opexesSalaryCopyCreate()` */
  static readonly OpexesSalaryCopyCreatePath = '/api/opexes/salary/{id}/copy/';

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryCopyCreate$Response(
    params: OpexesSalaryCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSalaryDto>> {
    return opexesSalaryCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryCopyCreate(params: OpexesSalaryCopyCreate$Params, context?: HttpContext): Observable<BackendSalaryDto> {
    return this.opexesSalaryCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSalaryDto>): BackendSalaryDto => r.body),
    );
  }

  /** Path part for operation `opexesSalaryEnumsRetrieve()` */
  static readonly OpexesSalaryEnumsRetrievePath = '/api/opexes/salary/enums/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesSalaryEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryEnumsRetrieve$Response(
    params?: OpexesSalaryEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesSalaryEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesSalaryEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesSalaryEnumsRetrieve(params?: OpexesSalaryEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.opexesSalaryEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
